<template>
  <div id="app">
    <loading ref="loading"/>
    <alert :alert="alert"></alert>
    <alert-novo></alert-novo>
        <!-- <div class="row"> -->
          <transition name="page" mode="out-in">
            <component v-if="layout" :is="layout"></component>
          </transition>
        <!-- modal de  configuração de impressão -->
        <open-modal-config-imprimir/>
  </div>
</template>

<script>

import Loading from './especiais/Loading'
import Alert from './especiais/Alert'
import AlertNovo from './especiais/Alert2'
import { mapState, mapActions } from 'vuex'

// Load layout components dynamically.
const requireContext = require.context('~/layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component
    return components
  }, {})

export default {
  el: '#app',

  components: {
    Loading, Alert, AlertNovo
  },

  data: () => ({
      layout: null,
      defaultLayout: 'default',
      alert: { show: false },
      SubMenuLink: [], // { titulo: 'Início' , ativo: true, url: '#/' },
      SubMenuBtn: [],// { titulo: 'Início' , ativo: false, url: '#/' },
      avisoImportante: true,
      filtroConta : {
          textPeriodo : 'Próximos 3 dias',
          de: moment().format("YYYY-MM-DD H:mm:ss"),
          ate: moment().add(3, 'days').format("YYYY-MM-DD H:mm:ss"),
          status: 'Todos',
          tipo: 'Receber',
          showPeriodo: false,
          pagination: true
      }

  }),

  metaInfo () {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },

  mounted () {
    this.$loading = this.$refs.loading
    // if (this.user) {
    //   this.loadConfigUser()
    // }
  },

  computed:{

      ...mapState('imprimir', ['imprimir']),

      ...mapState('auth', ['user'])

  },

  methods: {

    // ...mapActions('config', ['loadConfigUser']),
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout (layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    },

    // alert global
    alerta(type, title, message){
        this.alert = { show: true, type, title, message}
        setTimeout(()=>{
           this.alert.show = false
        },3000)
    },

    //fechar menu do botstrap
    fecharMenu(){
      $(".navbar-collapse").collapse('hide');
    }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue